export enum SimpleChoice {
  YES = 'Ja',
  NO = 'Nein',
}
